// extracted by mini-css-extract-plugin
export default {"previewViewerWrapper":"PDFPreview_previewViewerWrapper__BHjDi","selectedPDF":"PDFPreview_selectedPDF__IViHS"};